// src/components/store/sections/faqs/FaqV14BentohelpTealLagoon.tsx
"use client";

import React from "react";
import DynamicFaqVariant from "./DynamicFaqVariant";

export default function FaqV14BentohelpTealLagoon(props: any) {
  return (
    <DynamicFaqVariant
      variantNumber={14}
      archKey="bento_help"
      archLabel="Bento Help Matrix"
      palName="TealLagoon"
      grad="from-teal-500 via-cyan-600 to-emerald-700"
      lightBg="bg-teal-50"
      textCol="text-teal-700"
      borderCol="border-teal-200"
      btnCls="bg-teal-600 hover:bg-teal-700"
      hexCol="#14b8a6"
      {...props}
    />
  );
}
